import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsAverageAgeRoute: InvariantJiraRoute = {
	name: 'legacy-reports-average-age-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'],
};
